// extracted by mini-css-extract-plugin
export default {"TabDescription":"TabDescription-module-f389d6728972c018788d"};